// After a release the old hashed files are gone, so a tab still running the
// previous version fails the next time it loads a page it had not opened yet
// ("Failed to fetch dynamically imported module"). Reloading fetches the new
// version. Done at most once per 30 seconds, so a file that is really broken
// shows the error screen instead of reloading forever.

const KEY = 'regen:stale-chunk-reload-at'
const WINDOW_MS = 30_000

const CHUNK_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Failed to load module script|Unable to preload CSS/i

export function isChunkLoadError(err: unknown): boolean {
  const message = err instanceof Error ? err.message : typeof err === 'string' ? err : ''
  return CHUNK_ERROR.test(message)
}

/** Reloads the page unless it already did within the last 30 seconds.
 *  Returns true when it reloaded. */
export function reloadOnceForStaleChunk(
  now: number = Date.now(),
  storage: Pick<Storage, 'getItem' | 'setItem'> | null = safeStorage(),
  reload: () => void = () => window.location.reload(),
): boolean {
  try {
    const last = Number(storage?.getItem(KEY) ?? 0)
    if (last && now - last < WINDOW_MS) return false
    storage?.setItem(KEY, String(now))
  } catch {
    // Storage blocked: reload anyway, once per page load is the best we can do.
  }
  reload()
  return true
}

function safeStorage(): Storage | null {
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}
